/* eslint react/no-danger: "off" */
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import EmailShareButton from 'modules/Common/components/EmailShareButton';
import LinkShareButton from 'modules/Common/components/LinkShareButton';
import TwitterShareButton from 'modules/Common/components/TwitterShareButton';
import FacebookShareButton from 'modules/Common/components/FacebookShareButton';
import Ellipsis from 'modules/Common/components/Ellipsis';

import './ArticleSocialMediaButtons.scss'

class ArticleSocialMediaButtons extends Component {
  static contextTypes = {
    metrics: PropTypes.object
  };

  static propTypes = {
    copyFunction: PropTypes.func,
    timeoutFunction: PropTypes.func,
    dcmp: PropTypes.string,
    page: PropTypes.string
  };

  render() {
    return <div className="news-article-share-buttons-footer">
      <Ellipsis/>
      <div className="news-article-share-buttons-footer-inner">
        <div className="news-article-share-header">Like what you've read?</div>
        <div className="news-article-share-body">
          Help your friends Know It All by sharing this article to your social media.
        </div>
        <div className="news-article-media-button-container">
          <div className="news-article-media-button">
            <FacebookShareButton dcmp="article_bottom" {...this.props}/>
          </div>
          <div className="news-article-media-button">
            <TwitterShareButton dcmp="article_bottom" {...this.props}/>
          </div>
          <div className="news-article-media-button">
            <EmailShareButton dcmp="article_bottom" {...this.props}/>
          </div>
          <div className="news-article-media-button">
            <LinkShareButton dcmp="article_bottom" {...this.props}/>
          </div>
        </div>
      </div>
    </div>
  }
}

export default ArticleSocialMediaButtons;



// WEBPACK FOOTER //
// ./modules/News/components/ArticleSocialMediaButtons.js